// tslint:disable: max-line-length
import * as React from "react";
import { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const FilesIcon: FC<{ className?: string }> = (props) => {
    return (
        <SvgIcon viewBox="0 0 48 60" {...props}>
            <g fillRule="evenodd">
                <path d="M36.733 50H1.267C.567 50 0 49.44 0 48.75v-32.5c0-.332.134-.65.37-.885l15.2-15c.238-.232.56-.365.897-.365h20.266C37.433 0 38 .56 38 1.25v47.5c0 .69-.567 1.25-1.267 1.25zm-34.2-2.5h32.934v-45H16.99L2.533 16.767V47.5z" />
                <path d="M16.714 18H1.286C.576 18 0 17.424 0 16.714c0-.71.576-1.285 1.286-1.285h14.143V1.286c0-.71.576-1.286 1.285-1.286C17.424 0 18 .576 18 1.286v15.428c0 .71-.576 1.286-1.286 1.286zM41.733 55H6.267C5.567 55 5 54.44 5 53.75v-5c0-.69.567-1.25 1.267-1.25.699 0 1.266.56 1.266 1.25v3.75h32.934v-45h-3.8c-.7 0-1.267-.56-1.267-1.25S35.967 5 36.667 5h5.066c.7 0 1.267.56 1.267 1.25v47.5c0 .69-.567 1.25-1.267 1.25z" />
                <path d="M46.733 60H11.267c-.7 0-1.267-.56-1.267-1.25v-5c0-.69.567-1.25 1.267-1.25.699 0 1.266.56 1.266 1.25v3.75h32.934v-45h-3.8c-.7 0-1.267-.56-1.267-1.25S40.967 10 41.667 10h5.066c.7 0 1.267.56 1.267 1.25v47.5c0 .69-.567 1.25-1.267 1.25z" />
            </g>
        </SvgIcon>
    );
};

export default FilesIcon;
